export const clearCurrentFilterValuesReducer = (state) => {
    if (!state?.editor || !state?.editor?.settings) {
        return;
    }
    state.editor.settings.widgetFilterValues = {};
};
